/**
 * Typography tokens from the Yaxle type system.
 *
 * Families:
 * - `heading` / `body`: Geist (display through UI). Self-hosted from
 *   `public/fonts/` (variable TTFs declared in `public/index.html`).
 *   Weights map through the variable font: 400 regular, 600 semibold,
 *   700 bold, 900 black.
 * - `mono`: IBM Plex Mono (labels, footers).
 */
const geistStack =
	`'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif`;

export const fonts = {
	heading: geistStack,
	body: geistStack,
	mono: `'IBM Plex Mono', Menlo, Monaco, Consolas, 'Courier New', monospace`,
} as const;

export const fontSizes = {
	xs: '0.75rem', // 12px at 16px root
	sm: '0.875rem', // 14px
	md: '1rem', // 16px
	lg: '1.125rem', // 18px
	xl: '1.25rem', // 20px
	'2xl': '1.5rem', // 24px
	'3xl': '2rem', // 32px
	'4xl': '3rem', // 48px
	'5xl': '4.5rem', // 72px
	/**
	 * Text inputs on touch surfaces (the mobile embed). Fixed px on purpose:
	 * iOS zooms the viewport when a focused input computes under 16px, and
	 * the fluid rem root (ENG-2281) lands there on phone widths. Never
	 * convert to rem.
	 */
	touchInput: '16px',
} as const;

export const fontWeights = {
	normal: 400,
	medium: 500,
	semibold: 600,
	bold: 700,
	extrabold: 800,
} as const;

export const lineHeights = {
	none: 1,
	shorter: 1.07, // display
	short: 1.1,
	base: 1.375,
	tall: 1.5,
} as const;

export const letterSpacings = {
	tighter: '-0.02em', // H1
	tight: '-0.01em', // H2
	snug: '-0.005em', // H3
	normal: '0',
	wide: '0.01em', // CTA
	wider: '0.05em', // overline / mono label
	widest: '0.18em', // mono footer
} as const;

export default fonts;
